import { createSelector } from 'reselect'

const selectRawStarterContent = state => state.startercontent

const selectStarterContent = createSelector(
  selectRawStarterContent,
  startercontent => startercontent.startercontent
)

const selectStarterContentFetching = createSelector(
  selectRawStarterContent,
  startercontent => startercontent.isFetching
)

const selectCurrentPhoneStarterContentId = createSelector(
  selectRawStarterContent,
  startercontent => startercontent.currentPhoneId
)

export {
  selectStarterContent,
  selectStarterContentFetching,
  selectCurrentPhoneStarterContentId
}



// WEBPACK FOOTER //
// ./src/containers/GettingStarted/selectors.js